
import axios, { AxiosError } from 'axios';
import { Api } from '../../axios-config';

export interface IDetalheconfiguracoes {
  valorfaixa1: number;
  valorfaixa2: number;
  valorfaixa3: number;
  valorfaixa4: number;
  faixa2:number;
  aliquota1: number;
  aliquota2: number;
  aliquota3: number;
  aliquota4: number;
  remuneracao: number;
  idade: number;
  almoco: number;
  cafe: number;
  faltas1 :number;
  faltas2 :number;
  alivalor1 :number;
  alivalor2 :number;
  alivalor3 :number;
}

interface ErrorResponse {
  error: {
    default: string;
  };
}


const getAll = async (page = 1, ): Promise<IDetalheconfiguracoes | Error> => {
  try {
    const urlRelativa = `/configuracoes?page=${page}}`;

    const { data } = await Api.get(urlRelativa);

    if (data) {
      return data;
    }
 
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        if(axiosError.response.status === 402){
          return new Error('Acesso Negado');
        }else{
          const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
          return new Error(errorMessage);
        }
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const updateById = async (id: string, dados:IDetalheconfiguracoes): Promise<void | Error> => {
  try {
    await Api.put(`/configuracoes/${id}`, dados);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        if(axiosError.response.status === 402){
          return new Error('Acesso Negado');
        }else{
          const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
          return new Error(errorMessage);
        }
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

export const Configuracoes = {
  getAll,
  updateById 
};